import { setDocumentInUserContext } from '../../firebase/document/documentSagas';
import { RESIDENTS_PREFERENCES } from '../../../shared/collection/collectionConstants';

export default class UpsertResidentToFavoritesUseCase {
  static *upsert(failureCallback, action) {
    yield* setDocumentInUserContext(RESIDENTS_PREFERENCES, failureCallback, action);
  }
}
